import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { resources, SUPPORTED_LANGUAGES } from './i18n-resources'

const initOptions: any = {
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['localStorage', 'navigator', 'htmlTag'],
    caches: ['localStorage'],
  },

  ns: ['common', 'chat', 'pages', 'errors'],
  defaultNS: 'common',
  supportedLngs: SUPPORTED_LANGUAGES,

  react: {
    useSuspense: false,
  },
  initAsync: true,
  preload: SUPPORTED_LANGUAGES,
  saveMissing: false,
  missingKeyHandler: () => {
    // Missing translation tracked silently
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...initOptions,
    resources,
  })

export default i18n
